import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterSideNav from 'ui-addon-react-router-dom/UIRouterSideNav';
import UIRouterSideNavItem from 'ui-addon-react-router-dom/UIRouterSideNavItem';
import { HR } from 'foundations-components/transitional/components/HR';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { useAppSelector } from '../../app/indexReducer';
import { selectHasNewToYouGate } from '../../app/auth/GateSelectors';
import { TrackingAction, TrackingFeature, TrackingScreen, TrackingSubscreen, trackUsage } from '../../app/utils/tracking';
import handleError from '../../app/utils/handleError';
import useSideNavCounts from '../hooks/useSideNavCounts';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SideNav({
  category,
  processAllScheduledViewedPUs,
  unviewedPUIds
}) {
  const hasNewToYouGate = useAppSelector(selectHasNewToYouGate);
  const {
    recommendedCount,
    scheduledForReleaseCount,
    yourBetasCount,
    newToYouCount
  } = useSideNavCounts();
  const handleCategoryChange = nextCategory => {
    // update un-viewed count when switching tab
    if (category === nextCategory) {
      return;
    }
    if (processAllScheduledViewedPUs) {
      processAllScheduledViewedPUs().catch(e => {
        handleError(e, {
          description: 'processAllScheduledViewedPUs failed',
          errors: e
        });
      });
    }
  };
  return /*#__PURE__*/_jsxs(UIRouterSideNav, {
    children: [/*#__PURE__*/_jsx(UIRouterSideNavItem, {
      count: hasNewToYouGate ? newToYouCount : unviewedPUIds.size,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.sidebar.newToYou"
      }),
      to: "/new-to-you",
      onClick: () => {
        handleCategoryChange('new-to-you');
        trackUsage(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.NEW_TO_YOU, TrackingFeature.SIDEBAR_FILTER, TrackingAction.CLICK);
      }
    }), /*#__PURE__*/_jsx(UIRouterSideNavItem, {
      count: /*#__PURE__*/_jsx(_Fragment, {
        children: yourBetasCount
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.sidebar.yourBetas"
      }),
      to: "/your-betas",
      onClick: () => {
        handleCategoryChange('your-betas');
        trackUsage(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.YOUR_BETAS, TrackingFeature.SIDEBAR_FILTER, TrackingAction.CLICK);
      }
    }), /*#__PURE__*/_jsx(UIRouterSideNavItem, {
      count: /*#__PURE__*/_jsx(_Fragment, {
        children: recommendedCount
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.sidebar.recommended"
      }),
      to: "/recommended",
      onClick: () => {
        handleCategoryChange('recommended');
        trackUsage(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.RECOMMENDED, TrackingFeature.SIDEBAR_FILTER, TrackingAction.CLICK);
      }
    }), /*#__PURE__*/_jsx(UIRouterSideNavItem, {
      count: /*#__PURE__*/_jsx(_Fragment, {
        children: scheduledForReleaseCount
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.sidebar.scheduledForRelease"
      }),
      to: "/scheduled-for-release",
      onClick: () => {
        handleCategoryChange('scheduled-for-release');
        trackUsage(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.SCHEDULED_FOR_RELEASE_CALENDAR, TrackingFeature.SIDEBAR_FILTER, TrackingAction.CLICK);
      }
    }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(UIRouterSideNavItem, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.sidebar.all"
      }),
      to: "/all",
      onClick: () => {
        handleCategoryChange('all');
        trackUsage(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.ALL, TrackingFeature.SIDEBAR_FILTER, TrackingAction.CLICK);
      }
    }), /*#__PURE__*/_jsx(UIRouterSideNavItem, {
      iconLeft: /*#__PURE__*/_jsx(StatusTag, {
        color: "fill-positive-default"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.sidebar.live"
      }),
      to: "/live",
      onClick: () => {
        handleCategoryChange('live');
        trackUsage(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.LIVE, TrackingFeature.SIDEBAR_FILTER, TrackingAction.CLICK);
      }
    }), /*#__PURE__*/_jsx(UIRouterSideNavItem, {
      iconLeft: /*#__PURE__*/_jsx(StatusTag, {
        color: "fill-caution-default"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.sidebar.inBeta"
      }),
      to: "/in-beta",
      onClick: () => {
        handleCategoryChange('in-beta');
        trackUsage(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.IN_BETA, TrackingFeature.SIDEBAR_FILTER, TrackingAction.CLICK);
      }
    }), /*#__PURE__*/_jsx(UIRouterSideNavItem, {
      iconLeft: /*#__PURE__*/_jsx(StatusTag, {
        color: "border-core-subtle"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.sidebar.inDevelopment"
      }),
      to: "/in-development",
      onClick: () => {
        handleCategoryChange('in-development');
        trackUsage(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.IN_DEVELOPMENT, TrackingFeature.SIDEBAR_FILTER, TrackingAction.CLICK);
      }
    }), /*#__PURE__*/_jsx(UIRouterSideNavItem, {
      iconLeft: /*#__PURE__*/_jsx(StatusTag, {
        color: "fill-alert-default"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.sidebar.sunset"
      }),
      to: "/sunset",
      onClick: () => {
        handleCategoryChange('sunset');
        trackUsage(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.SUNSET, TrackingFeature.SIDEBAR_FILTER, TrackingAction.CLICK);
      }
    })]
  });
}